import { addBreadcrumb } from '@sentry/react';
import type { TrackedClick } from 'design-system';
import { logAnalytics } from 'utils/logAnalytics';

export const trackClick = ({ label, component, params }: TrackedClick) => {
  logAnalytics('select_content', params);
  addBreadcrumb({ category: 'click', message: `Clicked ${component} with label: ${label}`, data: params });
};
